import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter--sprite",
  "use": "filter--sprite-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" xmlns=\"http://www.w3.org/2000/svg\" id=\"filter--sprite\">\n<path d=\"M0 8H4V6.66667H0V8ZM0 0V1.33333H12V0H0ZM0 4.66667H8V3.33333H0V4.66667Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol